import React, { useEffect, useState } from 'react';
import api from '../../api/api';
import { Oval } from 'react-loader-spinner';
import AlertMessage from '../../Components/AlertMessage';

const EnvironmentVariables = () => {
  const [variables, setVariables] = useState();
  

  const [newVar, setNewVar] = useState({key : null, desc : null , type : 'TIME', period : 'DAYS', value : null});
  const [onCreating, setOnCreating] = useState(false)
  const [onDeleting, setOnDeleting] = useState(false)
  const [onError, setOnError] = useState(false)

  
  const handleAdd = async () => {


    try{
    setOnCreating(true)

    if(newVar.key && newVar.desc && newVar.value){

      if(newVar.type !== 'TIME'){
        newVar.period = null
      }

      await api.post('/settings/create', newVar)
              
      setVariables([...variables, newVar]);
      setNewVar({
        key : '', 
        desc : '', 
        type : 'TIME', 
        period : 'DAYS',
        value : ''
      });
    
    }
    // console.log(newVar)
  }catch(e){

    setOnError(true)
  }
    

    setOnCreating(false)

  };


  const deleteVar = async (id)=>{


    try{

      setOnDeleting(true)
      await api.post('/settings/delete', {id : id})

      setVariables(variables.filter((variable) => variable.id !== id));
      
    }catch(e){
    setOnError(true)

    }

    setOnDeleting(false)

  }


  useEffect(()=>{

    const fetchSets = async ()=>{

      try{

        const vars = await api.get('/settings');
        setVariables(vars.data)
        
      }catch(e){

      }

    }
    
    fetchSets()

  }, [])
  

  const handleDelete = (key) => {
  };

  return (
    <div className="min-h-screen p-8 ">

        {onError && <AlertMessage message={'Il ya eu une erreur'} type={'error'} onClose={()=>setOnError(false)}/>}
      

      <h1 className="mb-6 text-3xl font-bold text-white ">Variables</h1>

      <div className="p-6 mb-6 bg-white rounded-lg shadow-md dark:bg-gray-800">
        <h2 className="mb-4 text-xl font-semibold text-gray-800 dark:text-gray-100">Add New Variable</h2>
        <div className="flex space-x-4">
          <input
            type="text"
            placeholder="Variable Key"
            className="w-1/2 p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-indigo-50 dark:text-gray-200 dark:bg-gray-700 dark:border-gray-600 "
            value={newVar.key}
            onChange={(e) => setNewVar((prev)=>({ ...prev, key: e.target.value.toUpperCase() }))}
          />
          
          <input
            type="text"
            placeholder="Variable Value"
            className="w-1/2 p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:text-gray-200 dark:bg-gray-700 dark:border-gray-600 "
            value={newVar.value}
            onChange={(e) => setNewVar((prev)=>({ ...prev, value: e.target.value }))}
          />
          
        </div>


        <div className="flex space-x-4">
          <select
            className={`w-1/2 p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:text-gray-200 dark:bg-gray-700 dark:border-gray-600
`}
            value={newVar.type}
            defaultValue={'TIME'}
            onChange={(event)=>{
              setNewVar((prev)=>({ ...prev, type: event.target.value }))
              
              
            }}
          >
            <option value={'TIME'}>
              TEMPS
            </option>
            
            <option value={'VALUE'}>
              VALEUR SIMPLE
            </option>

            
          </select>


          {newVar.type === 'TIME' && <select
            className={`w-1/2 p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:text-gray-200 dark:bg-gray-700 dark:border-gray-600
`}
            value={newVar.period}
            defaultValue={'DAYS'}

            onChange={(event)=>{
              setNewVar((prev)=>({ ...prev, period: event.target.value }))
            }}
          >
            <option value={'DAYS'}>
              Jour
            </option>
            
            <option value={'WEEK'}>
              Semaine
            </option>
            
            <option value={'MONTH'}>
              Mois
            </option>
          </select>}
          
        </div>


        <div className="flex space-x-4">
          
          <textarea
            className="w-1/2 p-2 my-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:text-gray-200 dark:bg-gray-700 dark:border-gray-600 "
            placeholder='Description...'
            rows={5}
            onChange={(event)=>{
              setNewVar((prev)=>({...prev, desc : event.target.value}))
            }}
          />
          
        </div>
        
          {!onCreating && <div
            className="flex items-center justify-center px-4 py-2 text-white bg-indigo-600 rounded cursor-pointer hover:bg-indigo-700"
            onClick={handleAdd}
          >
            Add
          </div>}

          <div className="flex items-center justify-center px-4 py-2 text-white rounded cursor-progress ">
            {onCreating && <Oval
              height={20}
              width={20}
              color="#ffffff"
              visible={true}
              ariaLabel="oval-loading"
              secondaryColor="#cccccc"
              strokeWidth={2}
              strokeWidthSecondary={2}
            />}
          </div>
          
          
      </div>

      <div className="p-6 bg-white rounded-lg shadow-md dark:bg-gray-800">
        <h2 className="mb-4 text-xl font-semibold text-gray-800 dark:text-gray-100">Existing Variables</h2>
        {variables?.length > 0 ? (
          variables.map((variable, index) => (
            <div
              key={index}
              className="px-4 py-2 my-4 bg-gray-200 border-b-2 border-indigo-700 rounded-lg dark:bg-gray-700"
            >
                <div className='mb-5 text-gray-600 dark:text-gray-100'>
                    {
                        variable.desc
                    }
                </div>

                <div className='flex items-center justify-between'>
                    <div className="row-auto space-x-4 text-gray-700 dark:text-gray-100">
                        {variable.key}: 

                        <span>
                            {/* <input
                                type='number'
                                className='w-20 ml-5 bg-gray-200 border-0 rounded-md focus:bg-white focus:dark:bg-gray-700 dark:bg-gray-700'
                                value={variable.value}
                            /> */}
                            <p className='w-20 ml-5 bg-gray-200 border-0 rounded-md focus:bg-white focus:dark:bg-gray-700 dark:bg-gray-700'
                            >{variable.value}</p>
                        </span>

                        {variable.type === 'VALUE' && <span>
                            {/* <select
                                className='bg-gray-200 border-0 rounded-md w-30 focus:bg-white focus:dark:bg-gray-700 dark:bg-gray-700'
                                defaultValue={'DAYS'}
                            >
                                <option value={'DAYS'}>{'Days'}</option>
                                <option value={'WEEK'}>{'Week'}</option>
                                <option value={'MONTH'}>{'Month'}</option>
                            </select> */}
                            <p className='w-20 ml-5 bg-gray-200 border-0 rounded-md focus:bg-white focus:dark:bg-gray-700 dark:bg-gray-700'>
                              {variable.period}
                            </p>
                        </span>}
                    </div>
                    
                    {!onDeleting && <button
                        className="px-3 py-1 text-white bg-red-700 rounded-md hover:bg-red-600"
                        onClick={async() => await deleteVar(variable.id)}
                    >
                        Delete
                    </button>}

                  <div className="flex items-center justify-center px-4 py-2 text-white rounded cursor-progress ">
                    {onDeleting && <Oval
                      height={20}
                      width={20}
                      color="#ffffff"
                      visible={true}
                      ariaLabel="oval-loading"
                      secondaryColor="#cccccc"
                      strokeWidth={2}
                      strokeWidthSecondary={2}
                    />}
                  </div>
                </div>
            </div>
          ))
        ) : (
          <p className="text-gray-500">No environment variables set.</p>
        )}
      </div>
    </div>
  );
};

export default EnvironmentVariables;
